import { HttpEvent, HttpEventType, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { camelToSnakeCase } from '@helpers/case.helper';

/**
 * Sous-arbres dont les clés sont des noms métier et non des propriétés : les
 * règles de validation du task-scheduler sont nommées en PascalCase
 * (`NotBlank`, `DynamicDate`...) et la lib les recherche sous ce nom exact.
 */
const PRESERVED_RESPONSE_KEYS: ReadonlySet<string> = new Set(['validation_rules']);

export const caseNormalizationInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map((event: HttpEvent<unknown>) => {
      if (event.type !== HttpEventType.Response) {
        return event;
      }

      const response = event as HttpResponse<unknown>;
      if (
        response.body === null ||
        typeof response.body !== 'object' ||
        response.body instanceof Blob ||
        response.body instanceof ArrayBuffer
      ) {
        return event;
      }

      return response.clone({ body: camelToSnakeCase(response.body, PRESERVED_RESPONSE_KEYS) });
    }),
  );
};
